import React from "react";
import { Link } from "lucide-react";
import { toast } from "sonner";
import { Issue } from "@/types/issues";
import { getSafeRepositoryUrl } from "@/utils/utils";

import { PRDProject } from "./PRDProperties";
interface PRDHeaderProps {
  project: PRDProject;
  issue?: Issue;
}

const PRDHeader: React.FC<PRDHeaderProps> = ({ project, issue }) => {
  const handleRepositoryClick = () => {
    const safeUrl = getSafeRepositoryUrl(
      project?.provider || "github",
      project?.repoPath || "",
    );

    if (safeUrl) {
      window.open(safeUrl, "_blank", "noopener,noreferrer");
    } else {
      toast.error("Invalid repository path");
    }
  };

  if (!project?.repoPath) {
    return null;
  }

  return (
    <div className="flex items-center justify-between p-4 border-b border-border-primary bg-background-primary">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 text-text-secondary">
            <div className="text-xs text-text-secondary">
              {project.repoPath}
            </div>
            /
            <div>
              {issue && (
                <div className="text-xs text-text-primary font-medium">
                  {issue.canvas?.current_branch || issue.canvas?.id}
                </div>
              )}
            </div>
            <Link
              className="w-3 h-3 text-text-primary cursor-pointer"
              onClick={handleRepositoryClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PRDHeader;
